export const NAME_REGEX = /^[A-Za-z0-9 -]{1,100}$/;
export const CODE_REGEX = /^[A-Z]{2}$/;

export const toTitleCase = (str) =>
  str?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

export function filterOperators(
  data,
  { name = [], operator = [], error = [] },
  searchQuery = ''
) {
  const q = searchQuery?.toLowerCase?.() ?? '';
  return (data || []).filter((row) => {
    if (name.length && !name.includes(row.name)) return false;
    if (operator.length && !operator.includes(row.description)) return false;

    if (error.length === 1) {
      const hasError = row.errorsCount > 0;
      if (error[0] === 'Yes' && !hasError) return false;
      if (error[0] === 'No' && hasError) return false;
    }

    if (q && !`${row.name} ${row.description}`.toLowerCase().includes(q)) return false;
    return true;
  });
}

export function formatName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  if (trimmed.includes(',')) {
    const [last, first] = trimmed.split(',').map((s) => s.trim());
    if (first && last) return `${first} ${last}`;
  }
  return trimmed;
}

export function generateFileName(prefix = 'UI') {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${prefix}_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.csv`;
}
